import { useState } from 'react';
import { NavLink } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import Footer from './Footer';
import { useSelectedProduct } from '../contexts/SelectedProductContext';
import Carousel from './Carousel';

function Home() {
  const navigate = useNavigate();
  const { selectedProduct } = useSelectedProduct();
  // const [lgShow, setLgShow] = useState(false);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [show1, setShow1] = useState(false);
  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => setShow1(true);

  const [show2, setShow2] = useState(false);
  const handleClose2 = () => setShow2(false);
  const handleShow2 = () => setShow2(true);

  const [show3, setShow3] = useState(false);
  const handleClose3 = () => setShow3(false);
  const handleShow3 = () => setShow3(true);

  const [show4, setShow4] = useState(false);
  const handleClose4 = () => setShow4(false);
  const handleShow4 = () => setShow4(true);

  const [show5, setShow5] = useState(false);
  const handleClose5 = () => setShow5(false);
  const handleShow5 = () => setShow5(true);

  const [show6, setShow6] = useState(false);
  const handleClose6 = () => setShow6(false);
  const handleShow6 = () => setShow6(true);

  const [show7, setShow7] = useState(false);
  const handleClose7 = () => setShow7(false);
  const handleShow7 = () => setShow7(true);

  const [show8, setShow8] = useState(false);
  const handleClose8 = () => setShow8(false);
  const handleShow8 = () => setShow8(true);

  const [show9, setShow9] = useState(false);
  const handleClose9 = () => setShow9(false);
  const handleShow9 = () => setShow9(true);

  const handleNavigation = (path) => {
    navigate(`/${path}`); // navigate(`/${selectedProduct}/${path}`);
  };

  const backgroundImageStyle = {
    backgroundImage: 'url("/assets/images/bg-home.png")',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    height: '627px',
    width: '100%',
  };

  return (
    <>
      <div id="container">
        {/* <header>
          <div id="header-content">
          </div>
        </header>style={{ minHeight: '100vh', position: 'fixed' }} */}

        <div id="banner" className="pxy-70px pt-0" >
          <div className="row">
            <div className="col-sm-12 col-md-6 col-lg-6">
              <div className="bg-home" style={backgroundImageStyle}>
                <div className="banner-title-box pt-4">
                  <h2><span>HydroSecure Dashboard</span>  for Comprehensive  Disaster Risk Management and Climate Resilience Solutions</h2>

                  <h4>Data-Driven Community Empowerment, Partnership, and Collective Action</h4>
                  <p>HydroSecure is a digital platform that leverages cutting-edge technologies to address climate-induced water risks. It enhances real-time monitoring and early warning capabilities, providing high-resolution flood and drought assessments. The HydroSecure Dashboard is jointly supported by Digital Innovations for Water Secure Africa (DIWASA) initiative, supported by the Helmsley Foundation and AICCRA (Accelerating Impacts of CGIAR Climate Research for Africa) Zambia supported by World Bank.</p>
                  <p>In partnership with Digital Earth Africa (DEA), DIWASA bridges data and capacity gaps, enabling informed decision-making and fostering sustainable water management across the continent.</p>
                </div>
              </div>

            </div>
            <div className="col-sm-12 col-md-6 col-lg-6">

              {/* <img loading="lazy" alt="" src="/assets/images/banner-right-image.png" className="w-100" />  */}
              {/* hi */}
              <div className="p30-70px">
                <Carousel />
              </div>
              {/* <div className="home-map" style={{ position:'fixed' }}>
              
               
              </div> */}
            </div>
          </div>
        </div>

        <div id="content" className="">
          <section id="home" >
            <div className="section-one mt-70px" style={{ background: '#105586' }}>
              <div className="container-fluid">
                <div className="row">
                  <div className="col-sm-12 col-md-4 col-lg-5 px-0">
                    <div className="bg-one">
                      <h6 className="mb-0">Multi Hazard Mapping</h6>
                      <h3 className="mb-0">Multi-Hazard Mapping for Climate Adaptation in Africa</h3>
                      <h4 className="mb-0">Leveraging Data for Disaster Risk
                        Reduction and Resilience</h4>
                      <p>Multi-Hazard Mapping integrates data on various natural disasters to assess risk exposure and support climate adaptation. This dashboard visualizes hazard occurrences across Africa from 1950 to 2020, categorizing disasters by type, frequency, and impact. It provides spatially disaggregated data to enhance decision-making in disaster risk management.</p>
                      <p>Key insights include the most frequent hazards, affected administrative units, and population exposure levels. By improving data granularity, Maps aids governments, humanitarian organizations, and policymakers in planning effective disaster preparedness, response strategies, and sustainable resilience-building efforts.</p>
                      <NavLink to="" className="ps-0 linkAbout" style={{ padding: '10px 0px !important' }} onClick={handleShow3}>Read More <span><img loading="lazy" alt="" src="/assets/images/arrow_forward.png" /></span></NavLink>
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-8 col-lg-7 bg-white px-0">
                    <div className="bg-map-right m-auto">
                      <div className="bg-right-two">
                        <img loading="lazy" alt="risk-analysis" src="/assets/images/Multi_hazard.png" className="w-100" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="section-two" style={{ background: '#EF6400' }}>
              <div className="container-fluid">
                <div className="row">
                  <div className="col-sm-12 col-md-4 col-lg-5 px-0">
                    <div className="bg-two">
                      <h6 className="mb-0">Vulnerability and Risk Analysis</h6>
                      <h3 className="mb-0">Assessing Climate Risks to Africa’s Agriculture, Water, and Nutrition Security</h3>
                      <h4 className="mb-0">A Data-Driven Approach to Understanding Vulnerability and Enhancing Resilience</h4>
                      <p>The initiative evaluates the climate hazards, vulnerabilities, and risks impacting Africa’s agricultural, water, and nutritional security. It highlights the severe consequences of prolonged droughts on sustainable development, emphasizing regional disparities in exposure and adaptive capacity. Using a data-driven framework, the assessment identifies risk hotspots and socio-economic factors exacerbating vulnerabilities.</p>
                      <p>The findings offer critical insights for policymakers, urging evidence-based interventions in agriculture, water, and nutrition security. By integrating socio-economic policies with climate adaptation, Africa can enhance resilience and ensure sustainable development in the face of increasing climate challenges.</p>
                      <NavLink to="" className="ps-0 linkAbout" onClick={handleShow6} style={{ padding: '10px 0px !important' }} >Read More <span><img loading="lazy" alt="arrow_forward" src="/assets/images/arrow_forward.png" /></span></NavLink>
                    </div>
                  </div>

                  <div className="col-sm-12 col-md-8 col-lg-7 bg-white px-0">
                    <div className="bg-map-right m-auto">
                      <div className="bg-right-two">
                        <img loading="lazy" alt="risk-analysis" src="/assets/images/risk-analysis.svg" className="w-100  p-5" />
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>

            <div className="section-three" style={{ background: '#409BF6' }}>
              <div className="container-fluid">
                <div className="row">
                  <div className="col-sm-12 col-md-4 col-lg-5 px-0">
                    <div className="bg-three">
                      <h6 className="mb-0">Flood Forecasting and Early Warning</h6>
                      <h3 className="mb-0">Flood Early Warning System (FEWS) for African River Basins</h3>
                      <h4 className="mb-0">Enhancing flood resilience through data-driven early warning and forecasting solutions</h4>
                      <p>The Flood Early Warning System (FEWS) enhances flood preparedness for communities in Zambia, Ghana, Burkina Faso, and Ethiopia. Developed using Python, FEWS integrates real-time satellite and station data, weather forecasts, and hydrodynamic models to deliver accurate flood predictions. The system is designed for scalability, allowing seamless integration of local datasets for improved performance. Currently, FEWS is fully operational for the Kafue (Zambezi), Black Volta, and Awash River Basins, supporting decision-makers with timely and actionable flood risk insights.
                      </p>
                      <NavLink to="" className="ps-0 linkAbout" onClick={handleShow7} style={{ padding: '10px 0px !important' }}>Read More <span><img loading="lazy" alt="" src="/assets/images/arrow_forward.png" /></span></NavLink>
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-8 col-lg-7 bg-white px-0">
                    <div className="bg-map-right1">
                      <div className="bg-right-two">
                        <img loading="lazy" alt="food-early" src="/assets/images/food-early.png" className="w-100" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="section-three" style={{ background: '#10862A' }}>
              <div className="container-fluid">
                <div className="row">
                  <div className="col-sm-12 col-md-4 col-lg-5 px-0">
                    <div className="bg-four">
                      <h6 className="mb-0">Flood and Drought Monitor</h6>
                      <h3 className="mb-0">Flood and Drought Monitor from Space</h3>
                      <h4 className="mb-0">Real-time Earth Observation for Water Risk Management in Africa</h4>
                      <p>The Flood and Drought Monitor leverages Earth Observation (EO) data to provide real-time insights into flood and drought risks across Africa. By integrating NASA MODIS, ESA Sentinel-1, and Landsat datasets, the platform delivers high-resolution assessments at continental, national, and sub-national levels. This innovative tool enables governments, emergency responders, and researchers to monitor extreme events, enhance preparedness, and inform mitigation efforts. With data sourced from Digital Earth Africa (DEA) and AWS Open Data Registry,
                        HydroSecure ensures open access to critical water risk intelligence.</p>
                      <NavLink to="" className="ps-0 linkAbout" onClick={handleShow8} style={{ padding: '10px 0px !important' }} >Read More <span><img loading="lazy" alt="arrow_forward" src="/assets/images/arrow_forward.png" /></span></NavLink>
                    </div>
                  </div>
                  <div className="col-sm-12 col-md-8 col-lg-7 bg-white px-0">
                    <div className=" bg-map-right one">
                      <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-12">
                          <img loading="lazy" src="/assets/images/product2.png" className="w-100 " alt="product2" />
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="section-four" id="about" style={{ minHeight: '100vh' }}>
            <div className="container-fluid">
              <div className="row">
                <div className="col-sm-12 col-md-2 col-lg-2">
                  <div className="about-title">
                    <h6>About </h6>
                  </div>
                </div>
                <div className="col-sm-12 col-md-4 col-lg-4">
                  <div className="des-box">
                    <h2 className="mb-0">HydroSecure Dashboard</h2>
                    <h3>Data-Driven Collective Action for Water Risk Management in Africa</h3>
                    <p>The HydroSecure Dashboard provides insights into flood and drought risks across Africa using Earth Observation (EO) data from NASA MODIS, ESA Sentinel-1, and Landsat and hydrological modeling tools to inform timely early action for disaster risk management and climate resilience among regional to national agencies and development partners in decision making process. The dashboard using publicly accessible datasets and integrated Digital Earth Africa (DEA) assets and AWS, it enables early warning, disaster response, and climate resilience planning for policymakers and stakeholders.</p>
                    <NavLink to="" onClick={handleShow9} className="ps-0 linkAbout1 text-black" style={{ padding: '10px 0px !important' }}>Read More <span><img loading="lazy" alt="arrow_back" src="/assets/images/arrow_back.png" /></span></NavLink>
                  </div>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-6">
                  <div className="bg-img-right m-auto">
                    <div className="bg-right-six">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* <section className="section-five" id="" style={{ minHeight: '100vh' }}>
            <div className="container-fluid">
              <div className="row">
                <div className="col-sm-12 col-md-8 col-lg-8">
                  <div className="des-box-1">
                    <h2>Lorem Ipsum is a sample, Text used as a placeholder Lorem Ipsum has been</h2>
                  </div>
                </div>
                <div className="col-sm-12 col-md-4 col-lg-4">
                  <div className="text-right d-flex justify-content-end">
                    <NavLink to="" className="ps-0 linkAbout1" >Learn how it works <span><img loading="lazy" alt="" src="/assets/images/arrow_back.png" /></span></NavLink>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-12 col-md-6 col-lg-6">
                  <div className="center-img">
                    <img loading="lazy" src="/assets/images/left-1.png" className="w-100" alt="" />
                  </div>
                </div>
                <div className="col-sm-12 col-md-6 col-lg-6">
                  <div className="center-img">
                    <ListGroup as="ul" className="abtList">
                      <ListGroup.Item as="li" className="d-flex justify-content-between align-items-start active">
                        <div className="pe-3 numberText">
                          01
                        </div>
                        <div className="ms-2 me-auto">
                          <div className="fw-bold">Lorem Ipsum is simply dummy text of the printing  </div>
                          <p className="mb-0">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s</p>
                        </div>
                      </ListGroup.Item>
                      <ListGroup.Item as="li" className="d-flex justify-content-between align-items-start ">
                        <div className="pe-3 numberText">
                          02
                        </div>
                        <div className="ms-2 me-auto">
                          <p className="mb-0">Lorem Ipsum is simply dummy text of the printing  </p>
                        </div>
                      </ListGroup.Item>
                      <ListGroup.Item as="li" className="d-flex justify-content-between align-items-start">
                        <div className="pe-3 numberText">
                          03
                        </div>
                        <div className="ms-2 me-auto">
                          <p className="mb-0">Lorem Ipsum is simply dummy text of the printing  </p>
                        </div>
                      </ListGroup.Item>
                      <ListGroup.Item as="li" className="d-flex justify-content-between align-items-start">
                        <div className="pe-3 numberText">
                          04
                        </div>
                        <div className="ms-2 me-auto">
                          <p className="mb-0">Lorem Ipsum is simply dummy text of the printing  </p>
                        </div>
                      </ListGroup.Item>
                      <ListGroup.Item as="li" className="d-flex justify-content-between align-items-start">
                        <div className="pe-3 numberText">
                          05
                        </div>
                        <div className="ms-2 me-auto">
                          <p className="mb-0">Lorem Ipsum is simply dummy text of the printing  </p>
                        </div>
                      </ListGroup.Item>
                    </ListGroup>
                  </div>

                </div>
              </div>
            </div>
          </section> */}
          {/* <section className="section-five bg-white mb-5" id="dashboard" style={{ minHeight: '100vh' }}>
            <div className="container-fluid">
              <div className="row">
                <div className="col-sm-12 col-md-8 col-lg-8">
                  <div className="des-box-1">
                    <h2>Dashboards</h2>
                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text</p>
                  </div>
                </div>
                <div className="col-sm-12 col-md-4 col-lg-4">
                  <div className="text-right d-flex justify-content-end">
                    <a href="" className="ps-0 linkAbout1" onClick={() => handleNavigation('dashboard')}>Explore Dashboard <span><img loading="lazy" alt="" src="/assets/images/arrow_back.png" /></span></a>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <div className="center-img1">
                    <div className="card1 card-1">
                      <h6>Lorem Ipsum is simply dummy</h6>
                      <p className="mb-0">Lorem Ipsum is simply dummy text of the printing and typesetting industry. </p>
                    </div>
                    <div className="card1 card-2">
                      <h6>Lorem Ipsum is simply dummy</h6>
                      <p className="mb-0">Lorem Ipsum is simply dummy text of the printing and typesetting industry. </p>
                    </div>
                    <img loading="lazy" src="/assets/images/mackbook.svg" className="w-100" alt="MacBook" />
                    <div className="card1 card-3">
                      <h6>Lorem Ipsum is simply dummy</h6>
                      <p className="mb-0">Lorem Ipsum is simply dummy text of the printing and typesetting industry. </p>
                    </div>
                    <div className="card1 card-4">
                      <h6>Lorem Ipsum is simply dummy</h6>
                      <p className="mb-0">Lorem Ipsum is simply dummy text of the printing and typesetting industry. </p>
                    </div>
                    <div className="card1 card-5">
                      <h6>Lorem Ipsum is simply dummy</h6>
                      <p className="mb-0">Lorem Ipsum is simply dummy text of the printing and typesetting industry. </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section> */}

          <section className="impactStories p-70px" id="impactstories" style={{ minHeight: '100vh' }}>
            <div className="container-fluid">
              <div className="row">
                <div className="col-sm-12 col-md-5 col-lg-5">
                  <div className="impact-img1">
                    <img loading="lazy" src="/assets/images/DSC00117.jpg" alt="DSC00117" className="w-100" />
                  </div>
                </div>
                <div className="col-sm-12 col-md-7 col-lg-7">
                  <div className="textData">
                    <h5>Impact Stories</h5>
                    <h6>Building Climate Resilience: Impact Stories of Innovation and Action</h6>
                    <p>Innovative solutions are transforming climate resilience across Africa. From real-time flood monitoring and drought early warnings to anticipatory action and insurance solutions, these impact stories showcase how science-driven interventions are protecting lives, livelihoods, and food security in the face of climate extremes.</p>
                    <NavLink to="" className="ps-0 linkAbout2 text-black" style={{ padding: '10px  0px !important' }}>Explore Dashboard <span><img loading="lazy" alt="arrow_forward" src="/assets/images/arrow_forward.png" /></span></NavLink>
                  </div>
                </div>
              </div>

              <div className="row mt-45px">
                <div className="col-sm-12 col-md-4 col-lg-4">
                  <div className="card impact">
                    <div className="card-body p-0">
                      <h4>Real-Time Flood Monitoring Saves Lives in Kenya</h4>
                      <p>In May 2024, heavy rains and flash floods devastated Kenya,
                        displacing 150,365 people and affecting 191,000 individuals.
                        Using HydroSecure’s real-time flood maps and ESA Sentinel-1 SAR data, responders identified flood...</p>
                      <NavLink to="" className="ps-0 linkAbout1" onClick={handleShow} >Read More <span><img loading="lazy" alt="arrow_forward" src="/assets/images/arrow_back.png" /></span></NavLink>
                    </div>
                  </div>
                </div>
                <div className="col-sm-12 col-md-4 col-lg-4">
                  <div className="card impact">
                    <div className="card-body p-0">
                      <h4>Strengthening Drought Resilience for Farmers in Zambia</h4>
                      <p>During the 2023 El Niño drought, the Zambia Drought Management System (ZADMS),
                        developed with Zambia’s Ministry of Agriculture, provided early warnings by analyzing SPI, dry ....</p>
                      <NavLink to="" className="ps-0 linkAbout1" onClick={handleShow1} >Read More <span><img loading="lazy" alt="arrow_forward" src="/assets/images/arrow_back.png" /></span></NavLink>
                    </div>
                  </div>
                </div>
                <div className="col-sm-12 col-md-4 col-lg-4">
                  <div className="card impact">
                    <div className="card-body p-0">
                      <h4>Ghana’s Dry Spell Crisis: Urgent Actions to Protect Farmers and Food Security</h4>
                      <p>A severe dry spell in central and northern Ghana during the growing season in 2024 significantly impacted smallholder farmers, exacerbated by limited irrigation access... </p>
                      <NavLink to="" className="ps-0 linkAbout1" onClick={handleShow4}>Read More <span><img loading="lazy" alt="arrow_forward" src="/assets/images/arrow_back.png" /></span></NavLink>
                    </div>
                  </div>
                </div>

                <div className="col-sm-12 col-md-4 col-lg-4">
                  <div className="card impact">
                    <div className="card-body p-0">
                      <h4>Flood Insurance Empowering Farmers in Zambia</h4>
                      <p>In Zambia’s Southern Province, the Index-Based Flood Insurance (IBFI) pilot,
                        led by IWMI, ACRE Africa, and Zambia’s Professional Insurance Company Ltd, helps smallholder farm...</p>
                      <a href="https://www.cgiar.org/news-events/news/flood-risk-to-financial-security-how-index-based-flood-insurance-is-changing-lives-in-zambia/" target="_blank" className="ps-0 linkAbout1" >Read More <span><img loading="lazy" alt="arrow_forward" src="/assets/images/arrow_back.png" /></span></a>
                    </div>
                  </div>
                </div>

                <div className="col-sm-12 col-md-4 col-lg-4">
                  <div className="card impact">
                    <div className="card-body p-0">
                      <h4>Anticipatory Action Saves Lives in Zambia</h4>
                      <p>In Zambia, flood anticipatory action is enhancing disaster preparedness.
                        Supported by DIWASA, ClimBeR, and AICCRA, flood forecasting models provide early warnings,
                        enabling timely evacuations and livelihood protection...</p>
                      <NavLink to="" className="ps-0 linkAbout1" onClick={handleShow2}>Read More <span><img loading="lazy" alt="arrow_back" src="/assets/images/arrow_back.png" /></span></NavLink>
                    </div>
                  </div>
                </div>

                <div className="col-sm-12 col-md-4 col-lg-4">
                  <div className="card impact">
                    <div className="card-body p-0">
                      <h4>Policy to Action: Enhancing Zambia’s Drought Preparedness for a Resilient Future</h4>
                      <p>In response to the recent El Niño impact, IWMI, in collaboration with Zambia’s Ministry of Agriculture, is developing a National Drought Action Plan. ...</p>
                      <NavLink to="" className="ps-0 linkAbout1" onClick={handleShow5}>Read More <span><img loading="lazy" alt="arrow_back" src="/assets/images/arrow_back.png" /></span></NavLink>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </section>

          <div id="contact">
            <Footer />
          </div>
        </div>

        <Modal show={show} onHide={handleClose}
          size="lg"
          centered
          aria-labelledby="example-modal-sizes-title-lg"
        >
          <Modal.Body className="p-50px">
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">

                <div className="modalCard d-flex justify-content-between align-items-center mb-32px">
                  <div>
                    <h4>Real-Time Flood Monitoring Saves Lives in Kenya</h4>
                  </div>
                  <div className="cursor" onClick={handleClose}>
                    <img loading="lazy" src="/assets/images/cross.svg" alt="cross" />
                  </div>
                </div>
                <div className="card border-0 modalCard">
                  <div className="card-body p-0">
                    <p>In May 2024, heavy rains and flash floods devastated Kenya, displacing 150,365 people and affecting 191,000 individuals. Using HydroSecure’s real-time flood maps and ESA Sentinel-1 SAR data, responders identified flood extent in Nairobi and Kiambu. Insights were shared with NDMA and GloFAS, enabling timely evacuations and relief efforts. </p>
                    <div><img loading="lazy" src="/assets/images/modal-1.svg" className="w-100 mb-4" alt="modal-1" /></div>
                    <a href="https://zadmsdemo.iwmi.org/home" target="_blank" className="ps-0 linkAbout1 mt-5">Go to article <span><img loading="lazy" alt="arrow_back" src="/assets/images/arrow_back.png" /></span></a>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        <Modal show={show1} onHide={handleClose1}
          size="lg"
          centered
          aria-labelledby="example-modal-sizes-title-lg"
        >
          <Modal.Body className="p-50px">
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">

                <div className="modalCard d-flex justify-content-between align-items-center mb-32px">
                  <div>
                    <h4>Strengthening Drought Resilience for Farmers in Zambia</h4>
                  </div>
                  <div className="cursor" onClick={handleClose1}>
                    <img loading="lazy" src="/assets/images/cross.svg" alt="cross" />
                  </div>
                </div>
                <div className="card border-0 modalCard">
                  <div className="card-body p-0">
                    <p>During the 2023 El Niño drought, the Zambia Drought Management System (ZADMS), developed with Zambia’s
                      Ministry of Agriculture, provided early warnings by analyzing SPI, dry spells, NDVI, and IDSI. By mapping
                      drought-prone croplands, policymakers guided interventions,
                      helping farmers adopt water conservation techniques and drought-tolerant seeds, reducing losses.</p>
                    <div><img loading="lazy" src="/assets/images/DSC00078.jpg" className="w-100 mb-4" alt="DSC00078" /></div>
                    <a href="https://zadmsdemo.iwmi.org/home" target="_blank" className="ps-0 linkAbout1 mt-5">Go to article <span><img loading="lazy" alt="arrow_back" src="/assets/images/arrow_back.png" /></span></a>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        <Modal show={show2} onHide={handleClose2}
          size="lg"
          centered
          aria-labelledby="example-modal-sizes-title-lg"
        >
          <Modal.Body className="p-50px">
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">

                <div className="modalCard d-flex justify-content-between align-items-center mb-32px">
                  <div>
                    <h4>Anticipatory Action Saves Lives in Zambia</h4>
                  </div>
                  <div className="cursor" onClick={handleClose2}>
                    <img loading="lazy" src="/assets/images/cross.svg" alt="cross" />
                  </div>
                </div>
                <div className="card border-0 modalCard">
                  <div className="card-body p-0">
                    <p>In Zambia, flood anticipatory action is enhancing disaster preparedness. Supported by DIWASA, ClimBeR, and AICCRA, flood forecasting models provide early warnings, enabling timely evacuations and livelihood protection in high-risk areas. This proactive approach, integrating Earth Observation (EO) data and community engagement, strengthens resilience, reduces disaster impacts, and supports climate-adaptive water management.</p>
                    <div className="row">
                      <div className="col-sm-12 col-md-5 col-lg-5">
                        <div><img loading="lazy" src="/assets/images/ea-plans.svg" className="w-100 mb-4" alt="ea-plans" /></div>
                      </div>
                      <div className="col-sm-12 col-md-5 col-lg-5">
                        <div><img loading="lazy" src="/assets/images/rc.svg" className="w-100 mb-4" alt="rc" /></div>
                      </div>
                      <div className="col-sm-12 col-md-5 col-lg-5">
                        <div><img loading="lazy" src="/assets/images/rc-2.svg" className="w-100 mb-4" alt="rc-2" /></div>
                      </div>
                    </div>
                    <a href="https://www.iwmi.org/blogs/lessons-from-flood-anticipatory-action-in-zambia/" target="_blank" className="ps-0 linkAbout1 mt-5">Go to article <span><img loading="lazy" alt="arrow_back" src="/assets/images/arrow_back.png" /></span></a>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        <Modal show={show3} onHide={handleClose3}
          size="lg"
          centered
          aria-labelledby="example-modal-sizes-title-lg"
        >
          <Modal.Body className="p-50px">
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">

                <div className="modalCard d-flex justify-content-between align-items-center mb-32px">
                  <div>
                    <h4 className="mb-0">Multi-Hazard Mapping for Climate Adaptation in Africa</h4>
                  </div>
                  <div className="cursor" onClick={handleClose3}>
                    <img loading="lazy" alt="cross" src="/assets/images/cross.svg" />
                  </div>
                </div>
                <div className="card border-0 modalCard">
                  <div className="card-body p-0">
                    <p>Multi-Hazard Mapping consolidates data on natural disasters such as droughts, floods, epidemics, and storms to improve climate adaptation efforts across Africa. This dashboard provides insights into hazard occurrences from 1950 to 2020, based on EM-DAT and FloodList data, spatially disaggregated at the sub-national level for enhanced precision. </p>
                    <p>Floods and droughts are the most frequent hazards, significantly affecting population exposure and economic losses. Droughts impact 80% of Africa’s population, with Ethiopia, Kenya, and Niger being the most affected. Floods follow, affecting 16% of the population, particularly in Nigeria and Mozambique. Economic damages from floods account for 40% of reported losses, while storms and droughts contribute 31% and 27%, respectively. This detailed hazard mapping enables proactive risk management, ensuring targeted interventions and resource allocation. It supports policymakers, disaster agencies, and humanitarian organizations in implementing evidence-based strategies for disaster resilience, climate adaptation, and sustainable development across Africa.</p>
                    <a href="#" onClick={() => handleNavigation('product1/dashboard')} className="ps-0 linkAbout1 mt-5">Explore Dashboard <span><img loading="lazy" alt="arrow_back" src="/assets/images/arrow_back.png" /></span></a>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        <Modal show={show6} onHide={handleClose6}
          size="lg"
          centered
          aria-labelledby="example-modal-sizes-title-lg"
        >
          <Modal.Body className="p-50px">
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">

                <div className="modalCard d-flex justify-content-between align-items-center mb-32px">
                  <div>
                    <h4 className="mb-0">Assessing Climate Risks to Africa’s Agriculture, Water, and Nutrition Security</h4>
                  </div>
                  <div className="cursor" onClick={handleClose6}>
                    <img loading="lazy" src="/assets/images/cross.svg" alt="cross" />
                  </div>
                </div>
                <div className="card border-0 modalCard">
                  <div className="card-body p-0">
                    <p>Multi-Hazard Mapping integrates data on various natural disasters to assess risk exposure and support climate adaptation. This dashboard visualizes hazard occurrences across Africa from 1950 to 2020, categorizing disasters by type, frequency, and impact. It provides spatially disaggregated data to enhance decision-making in disaster risk management.</p>
                    <p>Key insights include the most frequent hazards, affected administrative units, and population exposure levels. By improving data granularity, Maps aids governments, humanitarian organizations, and policymakers in planning effective disaster preparedness, response strategies, and sustainable resilience-building efforts.</p>
                    <a href="#" onClick={() => handleNavigation('product2/dashboard')} className="ps-0 linkAbout1 mt-5">Explore Dashboard <span><img loading="lazy" alt="arrow_back" src="/assets/images/arrow_back.png" /></span></a>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        <Modal show={show7} onHide={handleClose7}
          size="lg"
          centered
          aria-labelledby="example-modal-sizes-title-lg"
        >
          <Modal.Body className="p-50px">
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">

                <div className="modalCard d-flex justify-content-between align-items-center mb-32px">
                  <div>
                    <h4 className="mb-0">Flood Early Warning System (FEWS) for African River Basins</h4>
                  </div>
                  <div className="cursor" onClick={handleClose7}>
                    <img loading="lazy" src="/assets/images/cross.svg" alt="cross" />
                  </div>
                </div>
                <div className="card border-0 modalCard">
                  <div className="card-body p-0">
                    <p>The Flood Early Warning System (FEWS) enhances flood preparedness for communities in Zambia, Ghana, Burkina Faso, and Ethiopia. Developed using Python, FEWS integrates real-time satellite and station data, weather forecasts, and hydrodynamic models to deliver accurate flood predictions. The system is designed for scalability, allowing seamless integration of local datasets for improved performance. Currently, FEWS is fully operational for the Kafue (Zambezi), Black Volta, and Awash River Basins, supporting decision-makers with timely and actionable flood risk insights.</p>
                    <a href="#" onClick={() => handleNavigation('product3/dashboard')} className="ps-0 linkAbout1 mt-5">Explore Dashboard <span><img loading="lazy" alt="arrow_back" src="/assets/images/arrow_back.png" /></span></a>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        <Modal show={show8} onHide={handleClose8}
          size="lg"
          centered
          aria-labelledby="example-modal-sizes-title-lg"
        >
          <Modal.Body className="p-50px">
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">

                <div className="modalCard d-flex justify-content-between align-items-center mb-32px">
                  <div>
                    <h4 className="mb-0">Flood and Drought Monitor from Space</h4>
                  </div>
                  <div className="cursor" onClick={handleClose8}>
                    <img loading="lazy" src="/assets/images/cross.svg" />
                  </div>
                </div>
                <div className="card border-0 modalCard">
                  <div className="card-body p-0">
                    <p>The Flood and Drought Monitor leverages Earth Observation (EO) data to provide real-time insights into flood and drought risks across Africa. By integrating NASA MODIS, ESA Sentinel-1, and Landsat datasets, the platform delivers high-resolution assessments at continental, national, and sub-national levels. This innovative tool enables governments, emergency responders, and researchers to monitor extreme events, enhance preparedness, and inform mitigation efforts. With data sourced from Digital Earth Africa (DEA) and AWS Open Data Registry, HydroSecure ensures open access to critical water risk intelligence.</p>
                    <a href="#" onClick={() => handleNavigation('product4/dashboard')} className="ps-0 linkAbout1 mt-5">Explore Dashboard <span><img loading="lazy" alt="" src="/assets/images/arrow_back.png" /></span></a>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        <Modal show={show9} onHide={handleClose9}
          size="lg"
          centered
          aria-labelledby="example-modal-sizes-title-lg"
        >
          <Modal.Body className="p-50px">
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">

                <div className="modalCard d-flex justify-content-between align-items-center mb-32px">
                  <div>
                    <h4 className="mb-0">HydroSecure Dashboard</h4>
                  </div>
                  <div className="cursor" onClick={handleClose9}>
                    <img loading="lazy" src="/assets/images/cross.svg" />
                  </div>
                </div>
                <div className="card border-0 modalCard">
                  <div className="card-body p-0">
                    <h5>Data-Driven Collective Action for Water Risk Management in Africa</h5>
                    <p>The HydroSecure Dashboard is an innovative, data-driven platform designed to enhance Africa’s resilience to climate-induced water risks. By leveraging Earth Observation (EO) data from NASA MODIS, ESA Sentinel-1, and Landsat, the dashboard delivers high-resolution flood and drought assessments at continental, national, and sub-national scales.</p>
                    <p>Flood monitoring combines MODIS 8-day composites for continental-scale flood mapping with Sentinel-1 SAR data for detailed national assessments. Drought analysis utilizes the Normalized Difference Drought Index (NDDI) to track vegetation stress and surface moisture.</p>
                    <p>Powered by AWS Open Data Registry, Digital Earth Africa (DEA) and AWS cloud processing, HydroSecure offers real-time monitoring, early warning, and decision support for governments, relief agencies, and researchers. It enhances informed decision-making, disaster preparedness, and adaptation planning while ensuring open access to critical tools for managing Africa’s evolving water security challenges</p>
                    {/* <a href="#"  className="ps-0 linkAbout1 mt-5">Explore Dashboard <span><img loading="lazy" alt="" src="/assets/images/arrow_back.png" /></span></a> */}
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        <Modal show={show4} onHide={handleClose4}
          size="lg"
          centered
          aria-labelledby="example-modal-sizes-title-lg"
        >
          <Modal.Body className="p-50px">
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">

                <div className="modalCard d-flex justify-content-between align-items-center mb-32px">
                  <div>
                    <h4>Ghana’s Dry Spell Crisis: Urgent Actions to Protect Farmers and Food Security</h4>
                  </div>
                  <div className="cursor" onClick={handleClose4}>
                    <img loading="lazy" src="/assets/images/cross.svg" />
                  </div>
                </div>
                <div className="card border-0 modalCard">
                  <div className="card-body p-0">
                    <p>A severe dry spell in central and northern Ghana during the growing season in 2024 significantly impacted smallholder farmers, exacerbated by limited irrigation access. A rapid assessment jointly conducted by WFP. FAO, WFP, IFAD, IWMI and UNICEF identified critical impacts on livelihoods, agriculture, water, and food security. Key findings include widespread crop failure (73% affected), livestock mortality (75%), declining water levels (80%), and rising food insecurity (95%). Market disruptions led to higher food prices and reduced purchasing power. The assessment informs short-, medium-, and long-term interventions to enhance resilience and food system stability.</p>
                    <div className="row">
                      <div className="col-sm-12 col-md-5 col-lg-5">
                        <div><img loading="lazy" src="/assets/images/ghana.jpg" className="w-100 mb-4" alt="" /></div>
                      </div>

                    </div>
                    <a href="https://openknowledge.fao.org/handle/20.500.14283/cd3443en" target="_blank" className="ps-0 linkAbout1 mt-5">Go to article <span><img loading="lazy" alt="" src="/assets/images/arrow_back.png" /></span></a>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        <Modal show={show5} onHide={handleClose5}
          size="lg"
          centered
          aria-labelledby="example-modal-sizes-title-lg"
        >
          <Modal.Body className="p-50px">
            <div className="row">
              <div className="col-sm-12 col-md-12 col-lg-12">

                <div className="modalCard d-flex justify-content-between align-items-center mb-32px">
                  <div>
                    <h4>Policy to Action: Enhancing Zambia’s Drought Preparedness for a Resilient Future</h4>
                  </div>
                  <div className="cursor" onClick={handleClose5}>
                    <img loading="lazy" src="/assets/images/cross.svg" />
                  </div>
                </div>
                <div className="card border-0 modalCard">
                  <div className="card-body p-0">
                    <p>In response to the recent El Niño impact, IWMI, in collaboration with Zambia’s Ministry of Agriculture, is developing a National Drought Action Plan. A multi-stakeholder workshop advanced data-driven solutions for proactive drought management across key sectors. Discussions focused on early warning systems, adaptive water management, and policy integration to mitigate risks. This engagement strengthens Zambia’s preparedness, empowering decision-makers with actionable insights to scale climate-smart solutions, ensuring sustainable water and agricultural resilience in the face of drought.</p>
                    <div className="row">
                      <div className="col-sm-12 col-md-12 col-lg-12">
                        <div><img loading="lazy" src="/assets/images/impact-new-img.png" className="w-100 mb-4" alt="" /></div>
                      </div>

                    </div>
                    <a href="https://www.cgiar.org/research/publication/national-workshop-on-the-drought-action-plan-for-zambia/" target="_blank" className="ps-0 linkAbout1 mt-5">Go to article <span><img loading="lazy" alt="" src="/assets/images/arrow_back.png" /></span></a>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>

      </div>
    </>
  )
}

export default Home